"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/chevron--left/32.js"));
var _2 = _interopRequireDefault(require("@carbon/icons-react/lib/chevron--right/32.js"));
var _3 = _interopRequireDefault(require("@carbon/icons-react/lib/close/32.js"));
var _ExternalVideo = _interopRequireDefault(require("../VideoSlide/ExternalVideo"));
var _PlayButton = _interopRequireDefault(require("../PlayButton/PlayButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.page-media-modal {\n  background: rgba(0, 0, 0, 0.7);\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 5;\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n  .page-media-modal .modal-container {\n    padding-inline: 24px;\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    justify-content: center;\n    display: flex;\n    align-items: center; }\n  .page-media-modal.single-image svg.previous,\n  .page-media-modal.single-image svg.next {\n    visibility: hidden; }\n  .page-media-modal svg {\n    color: white;\n    flex-shrink: 0; }\n    .page-media-modal svg.previous, .page-media-modal svg.next {\n      margin: 0; }\n    .page-media-modal svg:hover {\n      cursor: pointer; }\n  .page-media-modal .image-column {\n    position: relative;\n    height: inherit;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-inline: 16px; }\n    .page-media-modal .image-column .close-button {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      margin-bottom: 8px; }\n    .page-media-modal .image-column .image {\n      position: relative;\n      object-fit: contain;\n      width: 950px;\n      max-width: 100%;\n      display: flex;\n      justify-content: center; }\n      .page-media-modal .image-column .image img {\n        max-width: 100%;\n        max-height: 100%;\n        z-index: 5; }\n      .page-media-modal .image-column .image .external-video-wrapper {\n        position: absolute;\n        bottom: 52px;\n        right: 52px;\n        z-index: 5; }\n    .page-media-modal .image-column .page-info {\n      position: absolute;\n      display: flex;\n      justify-content: center;\n      width: 100%;\n      bottom: 16px;\n      color: white;\n      z-index: 5; }\n\n@media (max-width: 42rem) {\n  .page-media-modal {\n    align-items: flex-start;\n    padding-top: 64px; }\n    .page-media-modal .modal-container {\n      padding-inline: 8px; }\n    .page-media-modal .image-column {\n      padding-inline: 8px; }\n      .page-media-modal .image-column .image {\n        width: 100%; } }\n\n@media (max-width: 66rem) {\n  .page-media-modal .modal-container {\n    padding-inline: 4px; }\n  .page-media-modal .image-column {\n    padding-inline: 4px; }\n    .page-media-modal .image-column .image {\n      width: 100%;\n      position: relative; }\n      .page-media-modal .image-column .image .external-video-wrapper {\n        position: absolute;\n        right: calc(50% - 27px);\n        bottom: calc(50% - 27px); } }\n";
  const fileName = "PageMediaModal_PageMediaModal";
  const element = document.querySelector("style[data-sass-component='PageMediaModal_PageMediaModal']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const PageMediaModal = _ref => {
  let {
    isSingleImage,
    currentSlide,
    setCurrentSlide,
    onClose,
    imagesCount,
    currentModalImage
  } = _ref;
  const classes = ['page-media-modal', isSingleImage ? 'single-image' : null];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.join(' '),
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-container"
  }, /*#__PURE__*/_react.default.createElement(_.default, {
    className: 'previous',
    onClick: e => {
      e.stopPropagation();
      setCurrentSlide(currentSlide === 0 ? imagesCount - 1 : currentSlide - 1);
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "image-column"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "close-button"
  }, /*#__PURE__*/_react.default.createElement(_3.default, {
    className: 'close',
    onClick: () => {
      onClose();
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "image",
    onClick: e => {
      e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: currentModalImage.imagePlaceholder || currentModalImage.src,
    alt: ''
  }), currentModalImage.type === 'VIDEO' && /*#__PURE__*/_react.default.createElement("div", {
    className: "external-video-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_ExternalVideo.default, {
    itemSrc: currentModalImage.src,
    start_second: currentModalImage.start_second,
    stop_second: currentModalImage.stop_second
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'play-button-container'
  }, /*#__PURE__*/_react.default.createElement(_PlayButton.default, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: 'page-info'
  }, currentSlide + 1, " / ", imagesCount))), /*#__PURE__*/_react.default.createElement(_2.default, {
    className: 'next',
    onClick: e => {
      e.stopPropagation();
      setCurrentSlide(currentSlide + 1 === imagesCount ? 0 : currentSlide + 1);
    }
  })));
};

/*


*/
var _default = exports.default = PageMediaModal;